import { ReactNode } from 'react'
import { Button } from '../Button/Button'
import styles from './styles/DataTable.module.css'

type TableSelectionBarProps = {
  count: number
  onClear: () => void
  /** Ações em lote (ex.: <TableBulkDangerButton>). */
  children?: ReactNode
  /** Concordância do rótulo: ['selecionada', 'selecionadas']. */
  labels?: [string, string]
}

/** Substitui a toolbar quando há linhas selecionadas: "3 selecionadas · Cancelar seleção · ação". */
export const TableSelectionBar = ({
  count,
  onClear,
  children,
  labels = ['selecionado', 'selecionados'],
}: TableSelectionBarProps) => (
  <div className={styles.selectionBar}>
    <span role='status' className={styles.selectionCount}>
      {count} {count === 1 ? labels[0] : labels[1]}
    </span>
    <Button variant='tertiary' onClick={onClear}>
      Cancelar seleção
    </Button>
    {children}
  </div>
)

type TableBulkDangerButtonProps = {
  onClick: () => void
  children: ReactNode
  disabled?: boolean
}

export const TableBulkDangerButton = ({
  onClick,
  children,
  disabled,
}: TableBulkDangerButtonProps) => (
  <Button variant='danger-outline' onClick={onClick} disabled={disabled}>
    {children}
  </Button>
)

/** Botão "Limpar filtros" — mesmo botão do estado vazio. Renderize só com filtro ativo. */
export const ClearFiltersButton = ({ onClick }: { onClick: () => void }) => (
  <Button variant='secondary-outline' onClick={onClick}>
    Limpar filtros
  </Button>
)
